import { getAudioContextConstructor } from '../../hooks/useVoiceRecording'

/** Scales RMS so ordinary speech reaches about 1. */
export const LEVEL_GAIN = 4

/** Samples per level reading. */
export const LEVEL_WINDOW = 512

/** RMS of raw samples, scaled by LEVEL_GAIN; not capped, so a gate can compare loud frames. */
export const rmsLevel = (samples: Float32Array): number => {
  let sum = 0
  for (const sample of samples) sum += sample * sample
  return Math.sqrt(sum / samples.length) * LEVEL_GAIN
}

/** 0–1, an analyser's current window; 0 with no analyser yet. */
export const readLevel = (
  analyser: AnalyserNode | null,
  buffer: Float32Array<ArrayBuffer>,
): number => {
  if (!analyser) return 0
  analyser.getFloatTimeDomainData(buffer)
  return Math.min(1, rmsLevel(buffer))
}

export const createAnalyser = (context: AudioContext, fftSize = LEVEL_WINDOW): AnalyserNode => {
  const analyser = context.createAnalyser()
  analyser.fftSize = fftSize
  return analyser
}

/** Make it inside the click that asks for sound: one made after an await may start suspended. */
export const createLiveAudioContext = (): AudioContext => {
  const AudioContextImpl = getAudioContextConstructor()
  if (!AudioContextImpl) throw new Error('This browser can’t play live audio.')
  return new AudioContextImpl()
}
